import { CheckCircle } from '@mui/icons-material';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import {
  LP_INVESTOR_UPDATES,
  PERIOD_END_REPORT_LIST,
} from 'adminConstants/routes';
import { Row, Column } from 'further-ui/components/Layout';
import { Link as RouterLink } from 'react-router-dom';

const StyledColumn = styled(Column)(() => ({
  justifyContent: 'center',
  height: '100%',
}));

const Complete: React.FC = () => {
  return (
    <StyledColumn spacing="lg" centered>
      <Column spacing="xs" centered>
        <CheckCircle color="primary" fontSize="large" />
        <Typography variant="h4" align="center">
          Investor update successfully published
        </Typography>
        <Typography variant="body2" align="center">
          Your investor update has been processed and published to eligible
          investors.
        </Typography>
      </Column>
      <Row spacing="sm" centered>
        <Button
          component={RouterLink}
          size="large"
          variant="outlined"
          to={PERIOD_END_REPORT_LIST}
        >
          Start another update
        </Button>
        <Button
          component={RouterLink}
          size="large"
          variant="contained"
          to={LP_INVESTOR_UPDATES}
        >
          Go to Investor Updates
        </Button>
      </Row>
    </StyledColumn>
  );
};

export default Complete;
